import axios from 'axios'

// Use environment variable if available, otherwise use proxy
// CRITICAL: For Cloud Run deployment, VITE_API_URL must be set to the full backend URL.
// For local development, it defaults to '/api' which is proxied by Vite.
const baseURL = import.meta.env.VITE_API_URL || '/api'

// Debug: Log the API base URL being used
console.log('[API Config] Using base URL:', baseURL, 'from VITE_API_URL:', import.meta.env.VITE_API_URL)

export const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token and logging
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token')
  if (token) {
    const headers = config.headers as any
    if (headers && typeof headers.set === 'function') {
      headers.set('Authorization', `Bearer ${token}`)
    } else {
      (config.headers as Record<string, string>) = {
        ...(config.headers as Record<string, string>),
        Authorization: `Bearer ${token}`,
      }
    }
  }

  // Log API requests (without token)
  const headersObj = (config.headers as any) || {}
  const { Authorization, ...safeHeaders } = headersObj
  console.log(`🚀 API Request: ${config.method?.toUpperCase()} ${config.url}`, {
    baseURL: config.baseURL,
    headers: safeHeaders,
    data: config.data,
  })

  return config
})

// Response interceptor for error handling and logging
api.interceptors.response.use(
  (response) => {
    // Log successful responses
    console.log(`✅ API Response: ${response.config.method?.toUpperCase()} ${response.config.url}`, {
      status: response.status,
      data: response.data
    })
    return response
  },
  (error) => {
    // Log error responses
    console.error(`❌ API Error: ${error.config?.method?.toUpperCase()} ${error.config?.url}`, {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message
    })
    
    if (error.response?.status === 401) {
      // Clear auth token and redirect to login
      localStorage.removeItem('auth_token')
      localStorage.removeItem('user')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)
